module.exports = __webpack_public_path__ + "static/media/aramex.3a7de5e8.svg";